import type { ReactElement, ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

import { Notice } from '@/components';

export interface CardConflictNoticeProps {
  readonly title: string;
  readonly body: ReactNode;
  readonly action?: ReactNode;
}

export function CardConflictNotice({
  title,
  body,
  action,
}: CardConflictNoticeProps): ReactElement {
  return (
    <Notice
      tone="warn"
      icon={<AlertTriangle aria-hidden="true" className="size-4" />}
      title={title}
      body={body}
      action={action}
    />
  );
}
